import React from "react";
import { FaCheckCircle, FaListUl } from "react-icons/fa";

function StatCard({ icon, iconBg, iconColor, label, value, hint, valueColor = "#0f172a" }) {
  return (
    <div className="dal-stat-card">
      <div className="dal-stat-card__icon" style={{ backgroundColor: iconBg, color: iconColor }}>
        {React.cloneElement(icon, { size: 20 })}
      </div>
      <div className="dal-stat-card__body">
        <p className="dal-stat-card__label">{label}</p>
        <p className="dal-stat-card__value" style={{ color: valueColor }}>
          {value}
        </p>
        {hint ? <p className="dal-stat-card__hint">{hint}</p> : null}
      </div>
    </div>
  );
}

function DailyLogSummaryCards({ summary }) {
  const { completed, total, completionPct } = summary;
  const completedHint =
    total === 0
      ? "No tasks logged yet."
      : completionPct >= 70
      ? "Good going! Keep it up."
      : "Keep logging your progress.";

  return (
    <div className="dal-stat-grid">
      <StatCard
        icon={<FaCheckCircle />}
        iconBg="rgba(0, 161, 193, 0.12)"
        iconColor="#00a1c1"
        label="Tasks Completed"
        value={completed}
        hint={completedHint}
        valueColor="#00a1c1"
      />
      <StatCard
        icon={<FaListUl />}
        iconBg="rgba(124, 58, 237, 0.1)"
        iconColor="#7c3aed"
        label="Total Tasks"
        value={total}
        valueColor="#7c3aed"
        hint="Logged today"
      />
    </div>
  );
}

export default DailyLogSummaryCards;
